export default { sha: 'd764a06751bb069b2da800a58e265653cba413dc', buildNumber: 'undefined' }
